import numberBlacklist from "@/http/requests/numberBlacklist"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      numberBlacklist.fetch().then(response => {
        commit('SET_NUMBERS_BLACKLIST', response.data.data.numbersBlacklistQueue)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, customerId) {
    return new Promise((resolve, reject) => {
      numberBlacklist.add(customerId).then(response => {
        commit('ADD_NUMBER_BLACKLIST', response.data.data.createNumberBlacklistQueue)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      numberBlacklist.update(data).then(response => {
        commit('UPDATE_NUMBER_BLACKLIST', response.data.data.updateNumberBlacklistQueue)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, numberBlacklistId) {
    return new Promise((resolve, reject) => {
      numberBlacklist.delete(numberBlacklistId).then(response => {
        commit('DELETE_NUMBER_BLACKLIST', numberBlacklistId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  block({ commit }, numberBlacklistId) {
    return new Promise((resolve, reject) => {
      numberBlacklist.block(numberBlacklistId).then(response => {
        commit('BLOCK_NUMBER_FROM_BLACKLIST', response.data.data.blockNumberFromBlacklist)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
